<template>
  <vs-popup class="rm-order-po-pdf-popup"
            id="rm-order-po-pdf-pop-up"
            title="RM ORDER PO"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <vx-row>
        <vx-col>
          <div class="flex">
            <div class="flex">
              <vs-button @click="Print()" color="warning" type="border" >Print/Download</vs-button>
            </div>
          </div>
        </vx-col>
      </vx-row>

      <body id="myelement">

      <div id="full-wrap">


        <main class="clearfix">

          <div id="user" class="clearfix">

            <div id="user-top">

              <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                <tbody>
                <tr>
                  <td class="head">
                    <img id="logo"
                         src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                         alt="Logo" width="150" height="75" />
                  </td>
                  <td class="head">
                    <h4 style="color: #000000"><b>Purchase Order</b></h4>
                  </td>
                  <td class="head">
                    <div>
                      <p><b>VAT Reg No:</b> {{ data.vat_number }}</p>
                      <p><b>Company No:</b> {{ data.company_number }}</p>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colspan="3">
                    <table id="in-tbl">
                      <tr>
                        <td>
                          <div>
                            <p class="sml"><b>Supplier:</b></p>
                            <p class="sml">{{data.supplier_address.site_name }}</p>
                            <p class="sml">{{data.supplier_address.line1}}</p>
                            <p class="sml">{{data.supplier_address.line2}}</p>
                            <p class="sml">{{data.supplier_address.line3}}</p>
                            <p class="sml">{{data.supplier_address.town_state}}</p>
                            <p class="sml">{{data.supplier_address.post_code}}</p>
                            <p class="sml">{{data.supplier_address.country}}</p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>Deliver To:</b></p>
                            <p class="sml">{{data.deliver_to.name	}}</p>
                            <p class="sml">{{data.deliver_to.line1}}</p>
                            <p class="sml">{{data.deliver_to.line2}}</p>
                            <p class="sml">{{data.deliver_to.line3}}</p>
                            <p class="sml">{{data.deliver_to.town_state}}</p>
                            <p class="sml">{{data.deliver_to.post_code}}</p>
                            <p class="sml">{{data.deliver_to.country}}</p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>Invoice To:</b></p>
                            <p class="sml">{{data.invoice_to.name	}}</p>
                            <p class="sml">{{data.invoice_to.line1}}</p>
                            <p class="sml">{{data.invoice_to.line2}}</p>
                            <p class="sml">{{data.invoice_to.line3}}</p>
                            <p class="sml">{{data.invoice_to.town_state}}</p>
                            <p class="sml">{{data.invoice_to.post_code}}</p>
                            <p class="sml">{{data.invoice_to.country}}</p>
                          </div>
                        </td>

                      </tr>

                    </table>
                  </td>
                </tr>





                </tbody>
              </table>
              <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                <tbody>


                <tr>
                  <td colspan="3">
                    <table class="txt-center" id="in-tbl">
                      <tr>
                        <td width="34%">
                            <div>
                              <p class="sml"><b>Order Date</b></p>

                            </div>
                          </td>
                          <td width="33%">
                            <div>
                              <p class="sml"><b>Required By Date</b></p>

                            </div>
                          </td>
                          <td width="33%">
                            <div>
                              <p class="sml"><b>Order Number</b></p>

                            </div>
                          </td>

                      </tr>
                      <tr>
                        <td>
                            <div>
                              <p class="sml">{{ data.order_date }}</p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml">{{ data.required_by }}</p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml">{{ data.order_number }}</p>

                            </div>
                          </td>

                      </tr>

                    </table>
                  </td>
                </tr>





                </tbody>
              </table>
              <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                <tbody>


                <tr>
                  <td colspan="3">
                    <table class="txt-center" id="in-tbl">
                      <tr>
                        <td >
                          <div>
                            <p class="sml"><b>Delivery Date</b></p>

                          </div>
                        </td>
                        <td width="20%">
                          <div>
                            <p class="sml"><b>Supplier Item Code</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>ITS Product Code</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>Product Name</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>Unit</b></p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p><b>Quantity</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>Unit Price ({{ data.items[0] ? data.items[0].currency : '' }})</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>Value ({{ data.items[0] ? data.items[0].currency: '' }})</b></p>

                          </div>
                        </td>



                      </tr>

                      <tr v-for="(item, index) in data.items" :key="index">
                        <td>
                          <div>
                            <p>{{item.delivery_date}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{item.supplier_item_number}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{item.product_code}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{item.supplier_product_name}}</p>

                          </div>
                        </td>
                        <td>
                            <div>
                              <p>{{ item.unit }}</p>

                            </div>
                          </td>
                        <td>
                          <div>
                            <p>{{item.quantity}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{Number(item.price).toFixed(2)}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{Number(item.value).toFixed(2)}}</p>

                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td class="no-bd" colspan="5">
                          &nbsp;</td>
                        <td colspan="3">
                          <table class="no-bd-tbl">
                            <tr>
                              <td class="align-left">
                                <p><b>Net Order Value ({{ data.items[0] ? data.items[0].currency: '' }})</b></p>
                              </td>
                              <td class="align-right">{{totalCalculator()}}</td>
                            </tr>
                          </table>

                        </td>

                      </tr>

                    </table>
                  </td>
                </tr>

                </tbody>
              </table>

            </div>

          </div>

        </main>

        <footer>
          <p><b>Special Instruction:</b></p>
          <p>{{data.delivery_instruction}}</p>
          <small class="text-black">Generated on {{ __dateTimeFormatter(Date.now()) }}</small>
        </footer>

      </div>
      </body>
    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
const TradingRepository = RepositoryFactory.get('trading')
import { Printd } from 'printd'

function initialState() {
  return {
    open: false,
    id: '',
    data: {
      supplier_address: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: ''
      },
      deliver_to: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: ''
      },
      invoice_to: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: ''
      },
      order_date: '',
      order_number: '',
      items: [],
      delivery_instruction: '',
      generated_on: ''
    }
  }
}

export default {
  name: 'RmOrderPurchaseOrderPdfPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.open = true
        await this.getInvoiceDetails()
      } catch (error) {

      }
    },
    async getInvoiceDetails() {
      await this.$vs.loading({
        container: '#rm-order-po-pdf-pop-up',
        scale: 0.45
      })
      try {
        const {data} = await TradingRepository.getRmOrderPdfDetails(this.id)
        this.data =  data.data
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close('#rm-order-po-pdf-pop-up > .con-vs-loading')
    },
    totalCalculator() {
      let total = 0;
      this.data.items.forEach((m) => {
        if (!!m.price) {
          total = total + Number(m.value)
        }
      })
      return total.toFixed(2)
    },
    Print() {
      const d = new Printd()
      const styles = `html,
  body {
    -webkit-print-color-adjust: exact !important;
  }

  .clearfix:after {
    content: "";
    display: table;
    clear: both;
  }

  a {
    color: #0087C3;
    text-decoration: none;
  }

  body {
    position: relative;
    margin: 0 auto;
    color: #000000;
    background: #FFFFFF;
    font-family: Arial, sans-serif;
    font-size: 14px;
    line-height: 1.6;
  }

  div#full-wrap {
    width: 40cm;
    max-width: 100%;
    margin: 0 auto;
  }

  h4 {
    font-size: 24px;
  }

  p {
    font-size: 16px;
    margin: 0;
  }

  .sml {
    font-size: 14px;
  }

  main {
    padding: 0px 10px 20px 10px;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 20px;
    font-size: 13px;

  }

  table th,
  table td {
    padding: 20px;
    text-align: center;
    vertical-align: top;
  }

  table th {
    white-space: nowrap;
    font-weight: normal;
    color: #000;
  }

  table td {
    text-align: left;
  }

  table.txt-center td {
    text-align: center;
  }

  table.txt-left td {
    text-align: left;
  }

  table.txt-right td {
    text-align: right;
  }


  div#user-top {
    width: 100%;
    margin: 5em auto 2em auto;
  }

  div#user-top table {
    margin: 0 auto .8em auto;
    text-align: center;
    width: 100%;
  }

  div#user-top table td {
    padding: 5px 20px;
    font-size: 18px;
  }

  div#user-top .head {
    vertical-align: middle;
    text-align: center;

  }

  table#in-tbl {
    width: 100%;

  }

  table#in-tbl td {
    border: 2px solid #000;

  }

  td.no-bd {
    border-left: 0px !important;
    border-bottom: 0px !important;
  }

  table.no-bd-tbl td {
    border: 0px !important;
    padding: 0 !important;
  }

  table.no-bd-tbl {
    margin-bottom: 0 !important;
  }

  .align-left {
    text-align: left !important;
  }

  .align-right {
    text-align: right !important;
  }

  footer {
    padding: 0 30px;
  }
`
      d.print(document.getElementById('myelement'), [styles])
    }
  },
  components: {
    'v-select': vSelect
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.rm-order-po-pdf-popup >>> .vs-popup {
  /*min-height: 78% !important;*/
  min-width: 50% !important;
}

html,
body {
  -webkit-print-color-adjust: exact !important;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 5em auto 2em auto;
}

div#user-top table {
  margin: 0 auto .8em auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 20px;
  font-size: 18px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;
  padding: 0 !important;
}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

</style>

